import { useNavigate } from "react-router-dom";
import testCompletion from "../../assets/Images/test-completed.png";
import CustomButton from "../ReUsableComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { selectFullTestState } from "../../redux/Selectors/selectorsUse";

import { getItem } from "../../utils/token";
import macBook from "../../assets/Images/Macbook.svg";
import {
  setIsTestInstructionsOpen,
  setIsTestStarted,
} from "../../redux/Slices/startFullTestSlice";
import AuthButton from "../../pages/LogInPage/LoginButton";
import { FaRegStickyNote } from "react-icons/fa";
import Header from "../../pages/NewDashboard/Header";
import { RxHome } from "react-icons/rx";
import logoNew from "../../assets/Images/VerticalDarkLogo1.svg";
import sat from "../../assets/Images/SATprep1.svg";
import OnboardingBackground from "../ReUsableComponents/OnboardingBackground";

const TestCompleted = () => {
  const navigate = useNavigate();
  const { startTestSlice } = useSelector(selectFullTestState);
  const dispatch = useDispatch();
  const isPreview = getItem("testType") === "PREVIEW";
  const { userTestId } = startTestSlice;

  const handleReturntoHome = () => {
    dispatch(setIsTestInstructionsOpen(false));
    dispatch(setIsTestStarted(false));
  };

  return (
    <>
      <OnboardingBackground>
        <div className="flex flex-col items-center w-[720px] px-6 pt-6 pb-9 gap-9 rounded-2xl shadow-lg border border-satPrepGrey backdrop-blur-one bg-satPrepTransWhite mx-auto my-10">
          <div>
            <img
              src={logoNew}
              className="w-[260px] h-[163px] items-center"
              alt="FullMarks Logo"
            />
            <img
              src={sat}
              className="w-[211px] h-[68px] mx-auto"
              alt="SATprep Logo"
            />
          </div>

          <div className="text-center text-[40px] text-satPrepAccent font-bold font-gully">
            You’re All Finished!
          </div>

          {isPreview ? (
            <div className="flex flex-col items-center justify-center leading-6 w-[448px] rounded-md text-sm">
              <img src={testCompletion} alt="macbook" />
              <p className="text-center">
                Return to the homepage to start the preview again.
              </p>
              <p className="text-center mb-4">
                Reminder: there are no scores of feedback in this preview.
              </p>
              <p className="mb-6 min-w-11 text-center">
                When you see this page on test day, you'll know your scores have
                been submitted.
              </p>
              <AuthButton
                text="Return To Home"
                icon={<RxHome />}
                onClick={handleReturntoHome}
              />
            </div>
          ) : (
            <>
              <img
                className="w-[300px] h-[300px] mx-auto "
                src={testCompletion}
                alt="test completion"
              />
              <div className="text-[18px] text-satPrepBlack font-normal text-center">
                Congratulations on completing an SAT practice test.
              </div>
              <div className="w-full flex items-center justify-between">
                <AuthButton
                  text="Return To Home"
                  icon={<RxHome />}
                  onClick={handleReturntoHome}
                />
                <AuthButton
                  text="View Test Results"
                  onClick={() => navigate(`/practices/results/${userTestId}`)}
                  icon={<FaRegStickyNote />}
                />
              </div>
            </>
          )}
        </div>
      </OnboardingBackground>
    </>
  );
};

export default TestCompleted;
